import { ProductCardCoupon } from '@/features/shop/components/ProductCard/price/ProductCardCoupon'
import { ProductCardClickablePromotion } from '@/features/shop/components/ProductCard/price/ProductCardClickablePromotion'
import { getPromotionName } from '@/features/shop/components/ProductCard/Utils'
import { type ProductCardProduct } from '@/features/shop/components/ProductCard/types'
import { ProductPromotionContainer } from '@/features/shop/components/ProductCard/price/ProductPromotionContainer'
import { useIsVisitorOrZipOnly } from '@/features/account/services/User/hooks'
import { useCouponsContext } from '@/features/shop/components/Coupons/CouponsContext'
import { useIsPage } from '@/features/shared/hooks/useIsPage'

interface Props {
  product: ProductCardProduct
  isVertical?: boolean
  onClick?: () => void
}

export const ProductCardPromotion = ({ product, isVertical = false, onClick }: Props) => {
  const isVisitor = useIsVisitorOrZipOnly()
  const { bogo, couponId, cpgPromotion, promotionSubtotal, promotionMetadata } = product
  const coupon = useCouponsContext()?.[couponId]
  const {
    RETAILER_FEATURED_PROMOTIONS: isOnFeaturePromotionsPage,
    GLOBAL_SEARCH: isOnGlobalSearch,
  } = useIsPage()
  const isPromotionCompleted = promotionSubtotal !== undefined
  const hasLabelCategoryId = promotionMetadata?.label_category_id !== undefined
  const isExistingRewardItem = hasLabelCategoryId && promotionMetadata.should_prompt !== true

  if (isVisitor) return null
  if (!isVertical && couponId && !coupon) return null

  if (!isVertical && coupon) {
    return <ProductCardCoupon product={product} coupon={coupon} />
  }

  // we do not want to navigate / show chevron on global search or feature promos pages
  if (!isOnFeaturePromotionsPage && (cpgPromotion || hasLabelCategoryId) && !isOnGlobalSearch) {
    return (
      <ProductCardClickablePromotion
        cpgPromotion={cpgPromotion}
        isVertical={isVertical}
        isPromotionCompleted={isPromotionCompleted}
        promotionMetadata={promotionMetadata}
        selectedFreeItem={isExistingRewardItem ? product : undefined}
      />
    )
  } else {
    return (
      <ProductPromotionContainer
        size={isVertical ? 'md' : 'sm'}
        isVertical={isVertical}
        onClick={onClick}
      >
        {getPromotionName(cpgPromotion, bogo, isPromotionCompleted)}
      </ProductPromotionContainer>
    )
  }
}
